import { render, staticRenderFns } from "./ZoneBackground.vue?vue&type=template&id=34230974&scoped=true&"
import script from "./ZoneBackground.vue?vue&type=script&lang=ts&"
export * from "./ZoneBackground.vue?vue&type=script&lang=ts&"
import style0 from "./ZoneBackground.vue?vue&type=style&index=0&id=34230974&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34230974",
  null
  
)

export default component.exports